import { FileDetails } from "@/types/types";
import { handleDownload } from "@/utils/handleDownload";
import { CustomButton } from "@/components/ui/Buttons";
import FileIcon from "@/assets/icons/FileIcon.svg";
import DownloadIcon from "@/assets/icons/DownloadIcon.svg";
import { formatFileSize } from "@/utils/formatFileSize";
// import { formatFileSize } from "@/utils/formateSize";

interface FileDownloadSectionProps {
  file: FileDetails;
}

export const FileDownloadSection = ({ file }: FileDownloadSectionProps) => (
  <div className="mt-2 p-3 border border-[#F0EEEE] w-full rounded-xl flex justify-between items-center">
    <div className="flex gap-2 items-center">
      <FileIcon />
      <div>
        <h6 className="text-xs text-black font-medium">{file.name}</h6>
        <p className="text-[11px] text-[#959FB2]">
          {formatFileSize(file.size)}
        </p>
      </div>
    </div>
    <CustomButton
      variant="outline"
      fontSize="12px"
      fontWeight="500"
      onClick={() => handleDownload(file.live_url as string, file.name)}
      color="#000000"
      border="1px solid #D3D3D3"
      borderRadius="32px"
      padding="5px 12px"
      className="flex gap-x-1 items-center"
    >
      <DownloadIcon />
      Download
    </CustomButton>
  </div>
);
